import { notification } from 'ant-design-vue'

export default {
  methods: {
    showNotification(type, message, description) {
      notification[type]({ message, description })
    },

    showErrorNotification(error, fallbackMessage = 'Something went wrong') {
      const description = typeof error === 'string' ? error : error?.message || fallbackMessage
      this.showNotification('error', 'Error', description)
    }
  }
}
